export default __webpack_public_path__ + "static/media/redTheme-boy.74f6dfaa.svg";